// Sub menu structures
import { InvestmentsSubMenu } from "@/components/navigation/InvestmentsSubMenu"
import { FinanceSubMenu } from "@/components/navigation/FinanceSubMenu"
import { StatsSubMenu } from "@/components/navigation/StatsSubMenu"
import { CommunitySubMenu } from "@/components/navigation/CommunitySubMenu"
import { ProfileSubMenu } from "@/components/navigation/sub/ProfileSubMenu"

// Translations
import { useTrans } from "@/lib/i18n"

/**
 * Nav
 * @returns
 */
export function MainNavigation() {
	const t = useTrans()
	return (
		<nav
			aria-label={t("common:navigation.main")}
			className="mt-8 space-y-1 px-1 pb-4"
		>
			<StatsSubMenu />
			<InvestmentsSubMenu />
			<ProfileSubMenu />
			<CommunitySubMenu />
			<FinanceSubMenu />
		</nav>
	)
}
